import { graphql } from 'gql';

export const getCatalogsNamesByFilter = graphql(`
    query catalogsNamesByFilter($take: Int, $where: CatalogItemDataFilterInput) {
        catalogs(take: $take, where: $where) {
            items {
                name
            }
        }
    }
`);

export const catalogOtherCostVariablesGql = graphql(`
    query catalogOtherCostVariables(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $globalOnly: Boolean!
        $methodology: ProjectMethodologyEnum!
        $where: CatalogOtherCostVariableItemDataFilterInput
        $order: [CatalogOtherCostVariableItemDataSortInput!]
    ) {
        catalogOtherCostVariables(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            globalOnly: $globalOnly
            methodology: $methodology
            where: $where
            order: $order
        ) {
            items {
                canDelete
                dataSourceName
                formula
                groupName
                id
                name
                type
                dataSourceId
                entities {
                    isSystem
                    name
                    uniqueId
                }
                groupId
                uniqueId
                otherCostType {
                    id
                    isSystem
                    name
                    uniqueId
                }
                otherCostTypeId
                limitedCostType {
                    id
                    isSystem
                    name
                    uniqueId
                }
                limitedCostTypeId
                subsidiaryId
                subsidiaryName
            }
            totalCount
        }
    }
`);

export const otherCostVariablesNameFilterGql = graphql(`
    query catalogOtherCostVariablesNameFilter(
        $catalogUniqueId: String!
        $globalOnly: Boolean!
        $methodology: ProjectMethodologyEnum!
        $where: FilterValueOfStringFilterInput
    ) {
        catalogOtherCostVariablesNameFilter(
            catalogUniqueId: $catalogUniqueId
            globalOnly: $globalOnly
            methodology: $methodology
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const otherCostVariablesGroupFilterGql = graphql(`
    query catalogOtherCostVariablesGroupFilter(
        $catalogUniqueId: String!
        $globalOnly: Boolean!
        $methodology: ProjectMethodologyEnum!
        $where: FilterValueOfStringFilterInput
    ) {
        catalogOtherCostVariablesGroupFilter(
            catalogUniqueId: $catalogUniqueId
            globalOnly: $globalOnly
            methodology: $methodology
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);

export const otherCostVariablesSubsidiaryNameFilterGql = graphql(`
    query catalogOtherCostVariablesSubsidiaryNameFilter(
        $catalogUniqueId: String!
        $globalOnly: Boolean!
        $methodology: ProjectMethodologyEnum!
        $where: FilterValueOfStringFilterInput
    ) {
        catalogOtherCostVariablesSubsidiaryNameFilter(
            catalogUniqueId: $catalogUniqueId
            globalOnly: $globalOnly
            methodology: $methodology
            where: $where
        ) {
            items {
                value
            }
        }
    }
`);
